import React from 'react';
import PropTypes from 'prop-types';
import styles from './CardSummary.module.css';

const detailsShape = PropTypes.shape({
  listItems: PropTypes.array.isRequired,
}).isRequired;

const propTypes = {
  cardDetails: PropTypes.shape({
    title: PropTypes.string.isRequired,
    details: detailsShape,
  }).isRequired,
};

function ReportCardSummary({ cardDetails }) {
  const cardSummaryList = cardDetails.details.listItems.map((listItem, index) => {
    return <li className={styles['report-card-detail']} key={index}>{`${listItem}`}</li>;
  });

  const headerClasses = `${styles['report-card-title']} nwea-ds-v1-typography-subtitle`;

  return (
    <React.Fragment>
      <header className={headerClasses}>{cardDetails.title}</header>
      <ul className={styles['report-card-detail-list']}>{cardSummaryList}</ul>
    </React.Fragment>
  );
}

ReportCardSummary.propTypes = propTypes;

export default ReportCardSummary;
